module.exports = __webpack_public_path__ + "media/homepage/mirac-0093957a.png";